/**
 * Aktuális árfolyamokat lekérdező komponens
 * @author Erik Banhalmi 2017.05.17.
 */
import arfolyamServiceModule from './../../services/arfolyam-service';
import aktualisArfolyamokTemplate from './aktualis-arfolyamok.pug';
import aktualisArfolyamTabla from './../aktualis-arfolyam-tabla/aktualis-arfolyam-tabla';
const MODULE_NAME = 'aktualisArfolyamok';
class AktualisArfolyamokController {
	constructor(arfolyamService, $rootScope) {
		'ngInject';
		this.arfolyamService = arfolyamService;
		this.rootScope = $rootScope;
		this.showLoader = false;
		this.notEnoughData = false;
	}

	$onInit() {
		this.showLoader = true;
		this.arfolyamService.getAktualisArfolyamok().then((response) => {
			this.showLoader = false;
			this.aktualisArfolyam = response.data;
			if (!this.aktualisArfolyam.length) {
				this.notEnoughData = true;
			}
		}, (error) => {
			this.showLoader = false;
			this.rootScope.$broadcast('serverError');
			this.error = error;
		});
	}
}

export default angular.module(MODULE_NAME, [arfolyamServiceModule, aktualisArfolyamTabla])
	.component('aktualisArfolyamok', {
		controller: AktualisArfolyamokController,
		template: aktualisArfolyamokTemplate(),
		bindings: {
		}
	}).name;



// WEBPACK FOOTER //
// ../source/application/aktualis-arfolyamok/aktualis-arfolyamok/aktualis-arfolyamok.js